import styled from 'styled-components'

export const TermosContainer = styled.div`
  max-width: 900px;
  overflow: hidden;

  @media (max-width: 768px) {
    max-width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    padding: 10px;
  }

  @media (max-width: 425px) {
    h4 {
      text-align: center;
    }
  }
`

export const ConteudoTermos = styled.div`
  height: 600px;
  overflow: hidden;
  border-radius: 4px;
  margin-bottom: 15px;

  @media (max-width: 768px) {
    flex: 1;
    overflow: hidden;
    margin-bottom: 20px;
    height: 500px;
  }
`

export const BotoesContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
  margin-bottom: 5px;

  @media (max-width: 768px) {
    margin-top: 10px;
  }
`

export const AceitarTermos = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-start;
  margin-top: 20px;

  .mantine-Checkbox-input {
    border-color: #4f6275 !important;
  }

  .mantine-Checkbox-label {
    color: #000 !important;
  }

  @media (max-width: 768px) {
    flex-shrink: 0;
    margin-top: 10px;
  }
`
